import { Validator, unknown, valid, cannotBeEmptyString, mustBeValidEmail, cannotBeEmptySet } from "../../../../Shared/validationUtils";
import { Field, FormState } from "./newsletterFormBlockState";

export const validateField = <Field extends keyof FormState>(field: Field) =>
  (value: FormState[Field]) => {
    const fieldValidators = validator[field] as Validator<FormState[Field]>[]

    let result = unknown

    for (let i = 0; i < fieldValidators.length; i++) {
      result = fieldValidators[i](value)
      if (result.status != 'unknown') break
    }

    return result.status == "unknown" ? valid : result
  }

const validator: { [k in Field]: Validator<FormState[k]>[] } = {
  firstName: [],
  lastName: [
    cannotBeEmptyString("Achternaam mag niet ontbreken")
  ],
  emailAddress: [
    cannotBeEmptyString("E-mailadres mag niet ontbreken"),
    mustBeValidEmail("E-mailadres lijkt niet geldig")
  ],
  birthDate: [],
  newsletters: [cannotBeEmptySet("Kies minstens één nieuwsbrief")]
}
